import { SET_USER_TRANSACTIONS } from '../reducers/userTransactions';

export const acSetUserTransactions = (data) => ({
  type: SET_USER_TRANSACTIONS,
  payload: data,
});
